module.exports = __webpack_public_path__ + "static/media/3-akvaaerobika.0008014e.jpg";